/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Locale } from '@gh/core-mls';
import { ID } from '../common';

export abstract class UserData {
  abstract get id(): ID;

  abstract get firstName(): string;

  abstract get lastName(): string;

  abstract get fullName(): string;

  abstract get locale(): Locale;

  abstract get zoneId(): string;

  abstract get backendBuildNumber(): string;

  abstract get login(): string;
}
